import { render, staticRenderFns } from "./card_orders.vue?vue&type=template&id=e3f5dea8&scoped=true"
import script from "./card_orders.vue?vue&type=script&lang=js"
export * from "./card_orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f5dea8",
  null
  
)

export default component.exports